import {Box, Button, Link, Typography} from '@mui/material';
import {EntioCard, StatusBadge, getDeviceStatusVariant} from 'src/components/ui';
import {IntercomDevice} from 'src/apis/autoGenerate/types/intercomDevice';
import {getDeviceLocation, isDeviceOnline} from './types';

interface DoorControlCardProps {
  devices: IntercomDevice[];
  onViewAll: () => void;
  onOpenDoor: (device: IntercomDevice) => void;
}

export default function DoorControlCard({devices, onViewAll, onOpenDoor}: DoorControlCardProps) {
  const preview = devices.slice(0, 4);

  return (
    <EntioCard
      title="Door Control"
      headerAction={
        <Link
          component="button"
          underline="hover"
          variant="body2"
          onClick={onViewAll}
          sx={{fontWeight: 500}}
        >
          View All Devices &gt;
        </Link>
      }
    >
      {preview.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No doors available for your assigned properties.
        </Typography>
      ) : (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
          {preview.map(device => {
            const online = isDeviceOnline(device);
            return (
              <Box
                key={device.id}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                }}
              >
                <Box sx={{flex: 1, minWidth: 0, overflow: 'hidden'}}>
                  <Typography variant="subtitle2" noWrap>
                    {device.name || 'Door'}
                  </Typography>
                  <Box sx={{display: 'flex', alignItems: 'center', gap: 1, minWidth: 0}}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      noWrap
                      sx={{minWidth: 0, flex: 1}}
                    >
                      {getDeviceLocation(device)}
                    </Typography>
                    <StatusBadge
                      status={getDeviceStatusVariant(device.status)}
                      label={online ? 'Online' : 'Offline'}
                    />
                  </Box>
                </Box>
                <Button
                  variant="contained"
                  size="small"
                  disabled={!online}
                  onClick={() => onOpenDoor(device)}
                  sx={{flexShrink: 0}}
                >
                  Open Door
                </Button>
              </Box>
            );
          })}
        </Box>
      )}
    </EntioCard>
  );
}
